import type { TourAnalyticsContext } from './types';

// ── Homepage launcher ──────────────────────────────────────────────────────
// Delay before the launcher card slides in, so it doesn't compete with the
// page's own first paint.
export const MOUNT_DELAY_MS = 800;
export const ONBOARDING_KEY = 'home';
// In dev, always show the launcher regardless of dismissal state.
export const ALWAYS_SHOW_FOR_TESTING = process.env.NODE_ENV === 'development';

// Single source of truth for this tour's analytics identity (rows 18–35 of
// the analytics sheet — same shape for every tutorial). Drives both the
// launcher's own events and the tour runner's step events via the helpers
// from ./analytics, so the two can't drift apart.
export const TOUR_ANALYTICS: TourAnalyticsContext = {
  platform_page: 'Dashboard',
  feature_name: 'Dashboard',
  launcherHeaderText: 'Your new homepage',
};

// ── Button labels (reused as both the rendered label and the analytics
//    `button_text` property, so the two can't drift) ─────────────────────────
export const START_TOUR_BUTTON_TEXT = 'Start the 1 min tour';
export const REMIND_LATER_BUTTON_TEXT = 'Remind me later';
export const BACK_BUTTON_TEXT = 'Back';
export const CONTINUE_BUTTON_TEXT = 'Continue';
export const FINISH_BUTTON_TEXT = 'Finish';

// ── Tour overlay theme ─────────────────────────────────────────────────────
export const TOUR_THEME_CSS_ID = 'driverjs-onboarding-theme-style';

// ── Dismissal store ────────────────────────────────────────────────────────
export const MAX_REMIND_LATER_COUNT = 3;
export const DISMISSAL_EXPIRY_MS = 60 * 24 * 60 * 60 * 1000;
export const DISMISSAL_STORAGE_KEY = 'calyx-onboarding-dismissals-v1';
